export enum TechnicalCardSearchMethodEnum {
  ADMIN_CONSUMERS = "ADMIN_CONSUMERS",
  LOCATION = "LOCATION",
  ADVERTISING_CAMPAIGN = "ADVERTISING_CAMPAIGN",
  FRANCHISE = "FRANCHISE",
  NONE = "NONE"
}
